import { apiGet } from '../client';
import { BusinessDetailSchema, type BusinessDetail } from '../schemas';

/** Full detail (services, staff, hours, photos) for the profile/agenda screens. */
export function getBusiness(businessId: string): Promise<BusinessDetail> {
  return apiGet(`/v1/businesses/${encodeURIComponent(businessId)}`, BusinessDetailSchema);
}

/** The signed-in business's own detail, including when its storefront is still a draft. */
export function getOwnBusiness(): Promise<BusinessDetail> {
  return apiGet('/v1/business/profile', BusinessDetailSchema);
}
